import React, { Suspense } from 'react'
import { faFileWord, faPencil } from '@fortawesome/free-solid-svg-icons'
import Card from 'src/components/Card'
import useToggleState from 'src/hooks/useToggleState'
import Body from './Body'
import List from './List'
import EditModel from './EditModal'
import ReportModal from './ReportModal'
interface DetailsProps {
  id: number
}

const Details: React.FC<DetailsProps> = (props) => {
  const { id } = props
  const [isOpen, , handleToggle] = useToggleState()
  const [isReportOpen, , handleToggleReport] = useToggleState()

  return (
    <>
      <Card
        title='Position'
        primaryAction={{
          key: 'edit-position-details',
          icon: faPencil,
          onClick: handleToggle,
          permissionKey: 'CAT_EDIT'
        }}
        secondaryActions={[{
          key: 'position-summary-report',
          text: 'Summary Report',
          icon: faFileWord,
          onClick: handleToggleReport,
          permissionKey: 'CAT_EDIT'
        }]}
      >
        <Suspense fallback={<List position={undefined} />}>
          <Body id={id} />
        </Suspense>
      </Card>
      <EditModel id={id} isOpen={isOpen} toggle={handleToggle} />
      <ReportModal id={id} isOpen={isReportOpen} toggle={handleToggleReport} />
    </>
  )
}

export default Details
